<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--condition">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">CONDITION</div>
        <div class="workflow-node__title">
            {{ data?.config?.operator || 'AND' }}
            ({{ (data?.config?.rules || []).length }} rule{{ (data?.config?.rules || []).length !== 1 ? 's' : '' }})
        </div>
        <Handle type="source" :position="Position.Bottom" id="yes" style="left: 25%" />
        <Handle type="source" :position="Position.Bottom" id="else" style="left: 75%" />
        <div class="workflow-node__branch-labels">
            <span>Yes</span>
            <span>Else</span>
        </div>
    </div>
</template>

<style scoped>
.workflow-node__branch-labels {
    display: flex;
    justify-content: space-between;
    font-size: 9px;
    color: #fbbf24;
    margin-top: 4px;
    padding: 0 2px;
}
</style>
